/**
 * @author Gananath Athukorala
 * @version 0.1
 */

import React, { useEffect, useState } from "react"
import api from "../../services/AuthApi"
import { RequestErrorHandeling } from "../../errorHandeling/RequestErrorHandeling"
import { FetchErrorHandeling } from "../../errorHandeling/FetchErrorHandeling"
import UserAccountModal from "./UserAccountModal"

const UpdateUserAccount = ({ rowData, open, setIsUpdate, onClose }) => {
  const [values, setValues] = useState([])
  const [updatedValues, setUpdatedValues] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [isPrimContactValid, setIsPrimContactValid] = useState(false)
  const [isSecContactValid, setIsSecContactValid] = useState(false)
  const [isSubmit, setIsSubmit] = useState(false)
  const [errors, setErrors] = useState({
    primContact: "",
    secContact: "",
  })

  //for success messages
  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessages, setSuccessMessages] = useState([])

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [isUnauhtError, setIsUnauhtError] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  // Loading
  let getConfig = {
    headers: {},
  }

  // Satate Reset
  const handleClearData = () => {
    onClose()
    setUpdatedValues([])
    setIsSuccess(false)
    setSuccessMessages([""])
    setIserror(false)
    setIserrorShow(false)
    setIsUnauhtError(false)
    setErrorMessages([])
    setErrors({
      primContact: "",
      secContact: "",
    })
    setIsPrimContactValid(false)
    setIsSecContactValid(false)
    setIsLoading(true)
    setIsSubmit(false)
  }
  const fetchData = () => {
    api
      .get("/users/" + rowData?.username, getConfig)
      .then((res) => {
        setValues(res.data.dataList[0])
        setIsLoading(false)
        setUpdatedValues({ username: res.data.dataList[0].username })
      })
      .catch((error) => {
        console.log(error)
        FetchErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow,
          setIsUnauhtError
        )
      })
  }

  useEffect(() => {
    if (rowData.username) {
      fetchData()
    }
  }, [isUnauhtError, rowData?.username])

  const handleOnChange = (event) => {
    const { name, value } = event.target
    setValues({
      ...values,
      [name]: value,
    })
    setUpdatedValues({
      ...updatedValues,
      [name]: value,
    })
  }

  const checkValidatoin = (event) => {
    event.preventDefault()
    setErrors({
      primContact: "",
      secContact: "",
    })
    setIsPrimContactValid(false)
    setIsSecContactValid(false)

    const primContact = values.primContact
    const secContact = values.secContact

    if (primContact && (primContact.length < 10 || primContact.length > 20)) {
      setErrors({
        primContact: "Primary contact should be between 10 and 20 characters.",
      })
      setIsPrimContactValid(true)
    } else if (
      secContact &&
      (secContact.length < 10 || secContact.length > 20)
    ) {
      setErrors({
        secContact: "Secondary contact should be between 10 and 20 characters.",
      })
      setIsSecContactValid(true)
    } else if (primContact && primContact === secContact) {
      setErrors({
        primContact: "Primary and secondary contacts should not be equal.",
        secContact: "Primary and secondary contacts should not be equal.",
      })
      setIsPrimContactValid(true)
      setIsSecContactValid(true)
    } else {
      handleSaveRowEdits()
    }
  }

  // Update Profile
  const handleSaveRowEdits = () => {
    setIsUpdate(false)
    setIsSubmit(true)
    const formData = new FormData()
    const copyData = { ...updatedValues }
    copyData.username = rowData.username
    copyData.branchCode = null

    Object.keys(copyData).forEach((key) => {
      if (copyData[key] === "") {
        delete copyData[key]
      }
    })

    const profileData = new Blob([JSON.stringify(copyData)], {
      type: "application/json",
    })
    formData.append("profile_data", profileData)
    // Create new user config
    let postConfig = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }

    api
      .put("/users", formData, postConfig)
      .then((res) => {
        setErrorMessages([])
        setIserror(false)
        setErrorMessages([])
        setIsUnauhtError(false)
        setIsSuccess(true)
        setSuccessMessages([res.data?.description])
        setTimeout(() => {
          setIsUpdate(true)
          handleClearData()
        }, 3000)
      })
      .catch((error) => {
        setIsSubmit(false)
        setIsSuccess(false)
        RequestErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow,
          setIsUnauhtError
        )
      })
  }

  return (
    <UserAccountModal
      open={open}
      values={values}
      title="Update User Account"
      handleSave={checkValidatoin}
      handleOnChange={handleOnChange}
      handleClearData={handleClearData}
      isLoading={isLoading}
      isPrimContactValid={isPrimContactValid}
      isSecContactValid={isSecContactValid}
      isSubmit={isSubmit}
      errors={errors}
      isSuccess={isSuccess}
      successMessages={successMessages}
      iserror={iserror}
      iserrorShow={iserrorShow}
      errorMessages={errorMessages}
      userRoleDisabled={true}
      userNameDisabled={true}
      visibility="none"
      orgCode={values.orgCode}
    />
  )
}

export default UpdateUserAccount
